import { withQueueAgents } from 'hocs';
import { QueuesAgents as QueuesAgentsImpl } from '../components/queuesAgents';
const QueuesAgentsWithHOC = withQueueAgents(QueuesAgentsImpl);
export { QueuesAgentsWithHOC as QueuesAgents };
